import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a2e9dd72"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guide-menu"
};
const _hoisted_2 = ["textContent"];
const _hoisted_3 = {
  key: 0,
  class: "menu-body"
};
import { ref } from 'vue';
import GuideRenderer from '@/components/guide/GuideRenderer.vue';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const open = ref(false);
    const toggle = () => {
      open.value = !open.value;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "menu-head",
        onClick: toggle
      }, [_createElementVNode("div", {
        class: "menu-title",
        textContent: _toDisplayString(__props.title)
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        class: _normalizeClass(["menu-icon", {
          open: open.value
        }]),
        src: "https://p6.moimg.net/md/guide/guide_img_09.png",
        alt: "toggle"
      }, null, 2)]), open.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(GuideRenderer, {
        items: __props.content
      }, null, 8, ["items"])])) : _createCommentVNode("", true)]);
    };
  }
};